"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.seCountry = void 0;
var _utils = require("../utils");
var _companyNumber = require("../../companyNumber");
// i18next-extract-mark-ns-start Countries

var seCountry = exports.seCountry = function seCountry(t) {
  return {
    id: 'SE',
    name: t('Sweden'),
    flag: '🇸🇪',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      var regex = /^[0-9]{3}\s?[0-9]{2}$/;
      return regex.test(zipcode);
    },
    zipcodeMatcher: _utils.defaultZipcodeMatcher,
    zipcodePlaceholder: 'e.g. 100 00 or 602 00',
    phonePrefix: '46',
    phoneLength: 9,
    pricingVersion: 14,
    timezone: 'Europe/Stockholm',
    currency: 'EUR',
    companyNumber: {
      label: _companyNumber.labels.SE,
      checker: _companyNumber.checkers.SE,
      placeholder: '5567037485'
    }
  };
};